<template>
	<el-container id="app" style="height:100vh;">

		<router-view v-if="is_login" style="margin-bottom:3.4rem" />

		<el-container v-if="is_index">
			<!--左侧导航Start-->
			<left-nav :isCollapse="this.$store.state.isCollapse"></left-nav>
			<!--左侧导航End-->
			<!--右侧内容Start-->
			<el-container class="body">
				<el-header style="height: 56px;background: #FFFFFF;">
					<top-header></top-header>

				</el-header>

				<el-main>

					<transition name="el-fade-in-linear">
						<router-view style="margin-bottom:3.4rem" />
					</transition>
				</el-main>
			</el-container>
			<!--右侧内容End-->

		</el-container>
	</el-container>

</template>

<script>
	import Nav from '@/components/common/Nav'
	import Header from '@/components/common/Header'
	export default {
		name: 'App', //入口文件
		data() {
			return {

			}
		},
		components: {
			'left-nav': Nav,
			'top-header': Header
		},
		created() {
			console.log(this.$route.name)
		},
		computed: {
			is_login() {
				if(this.$route.name == 'login' || this.$route.name == 'reg' || this.$route.name == 'forget') {
					return true
				} else {
					return false
				}
			},
			is_index() {
				if(this.$route.name != 'login' && this.$route.name != 'reg' && this.$route.name != 'forget' && this.$route.name != null) {
					return true
				} else {
					return false
				}
			}
		}

	}
</script>

<style>
	#app {
		font-family: "Hiragino Sans GB", "Helvetica" !important;
		-webkit-font-smoothing: antialiased !important;
		;
		-moz-osx-font-smoothing: grayscale !important;
		;
		text-align: center;
		color: #2c3e50;
		word-wrap: break-word;
		word-break: normal;
		-webkit-logical-height: -webkit-fill-available !important;
		;
		background: #f0f2f5;
	}
	/*单图片上传*/
	
	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}
	/*统一图标*/
	
	.pub-icon {
		width: 24px;
		display: inline-block;
		margin-right: 5px;
	}
</style>


// WEBPACK FOOTER //
// src/App.vue